export default {
  install: (app) => {
    app.config.globalProperties.$log = (...values) => console.log(...values);
  },
};
